<template>
  <div class="filter-card">
    <div class="d-flex justify-content-between">
      <h6>{{ title }}</h6>
      <span v-if="lastSaved"><i class="text-muted">Cập nhập lúc: {{ lastSaved|formatDate('DD-MM-YYYY, H:m') }}</i></span>
    </div>

<!--    <pre>{{conditions}}</pre>-->

    <ul class="mt-2 mb-2" v-if="conditions.length">
      <li v-for="(condition, index) in conditions" :key="index"
          v-if="condition.gt || condition.lt || (condition.value && condition.value.length)">
        <b-row>
          <b-col cols="5"><span class="d-inline-flex" style="font-size: 12px">{{ index + 1 }}.<u class="ml-1">{{ (condition.label ? condition.label : condition.key)|removeBr }}</u>:</span>
          </b-col>
          <b-col cols="7">

            <span
              v-if="condition.gt !== null && condition.gt !== undefined && condition.gt!==''">≥ {{ condition.gt }}</span>

            <span class="ml-2"
                  v-if="condition.lt !== null && condition.lt !== undefined && condition.lt!==''">≤ {{ condition.lt }}</span>

            <span v-if="condition.value && condition.value.length">{{ condition.value }}</span>
          </b-col>
        </b-row>
      </li>
    </ul>
    <div class="d-flex justify-content-between">
      <p class="mb-0">Tổng lần dùng: <b v-if="totalUses >=0">{{ totalUses > 0 ? totalUses : ' đang cập nhập' }}</b></p>
      <span v-if="lastUsed"><i class="text-muted">Sử dụng lần cuối: {{ (lastUsed?lastUsed:' đang cập nhập')|formatDate('DD-MM-YYYY, H:m') }}</i></span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'FilterCard',
  props: {
    title: {
      type: String,
      required: true
    },
    lastSaved: {
      type: String,
      required: false
    },
    lastUsed: {
      type: String,
      required: false
    },
    conditions: {
      type: Array,
      required: true,
      default: () => []
    },
    totalUses: {
      type: Number,
      required: true
    }
  },
  filters: {
    removeBr(text) {
      return text ? text.replaceAll('<br>',''):'';
    }
  }
};
</script>

<style scoped>
.filter-card {
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 5px;
  margin-bottom: 1rem;
}

.filter-card h3 {
  margin-top: 0;
}

.filter-card ul {
  list-style: none;
  padding: 0;
  /*columns: 2;*/

}

.filter-card ul li {
  margin-bottom: 0.5rem;
}

.filter-card p {
  margin: 0.5rem 0;
}
</style>

